import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_DISCOUNTS_DATA, FETCH_DISCOUNTS_EDIT_DATA } from "./actionTypes";
import {
  fetchDiscountsSuccess,
  fetchDiscountsFailure,
  fetchDiscountsEditSuccess,
  fetchDiscountsEditFailure,
} from "./actions";

function* fetchDiscountsDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/discounts",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log(response);
    yield put(fetchDiscountsSuccess(response.data));
  } catch (error) {
    yield put(fetchDiscountsFailure(error.message));
  }
}

function* fetchDiscountsEditDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/discounts/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log(response);
    yield put(fetchDiscountsEditSuccess(response.data));
  } catch (error) {
    yield put(fetchDiscountsEditFailure(error.message));
  }
}

export default function* discountsSaga() {
  yield takeEvery(FETCH_DISCOUNTS_DATA, fetchDiscountsDataSaga);
  yield takeEvery(FETCH_DISCOUNTS_EDIT_DATA, fetchDiscountsEditDataSaga);
}
